module.exports = __webpack_public_path__ + "static/media/bdbi.svg:Zone.7a821669.Identifier";